// Free Google Maps embed — no API key required.
// Accepts the same `points` prop as before: [{ lat, lng, title, sub }]
// Uses the average center of all valid points; falls back to name-based search.
export default function MapView({ points = [], height = 320, query = '' }) {
  const valid = points.filter((p) => typeof p.lat === 'number' && typeof p.lng === 'number')

  let src
  if (valid.length > 0) {
    const lat = valid.reduce((s, p) => s + p.lat, 0) / valid.length
    const lng = valid.reduce((s, p) => s + p.lng, 0) / valid.length
    const zoom = valid.length === 1 ? 13 : 8
    src = `https://maps.google.com/maps?q=${lat},${lng}&z=${zoom}&output=embed`
  } else if (query) {
    src = `https://maps.google.com/maps?q=${encodeURIComponent(query)}&output=embed`
  } else {
    // Dhaka, Bangladesh as default fallback
    src = `https://maps.google.com/maps?q=23.8103,90.4125&z=13&output=embed`
  }

  return (
    <div style={{ height, borderRadius: 14, overflow: 'hidden', border: '1px solid #c8d1de' }}>
      <iframe
        src={src}
        width="100%"
        height="100%"
        style={{ border: 0, display: 'block' }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Trip location map"
      />
    </div>
  )
}
